import { render, staticRenderFns } from "./Compositions.vue?vue&type=template&id=0875e197"
import script from "./Compositions.vue?vue&type=script&lang=js"
export * from "./Compositions.vue?vue&type=script&lang=js"
import style0 from "./Compositions.vue?vue&type=style&index=0&id=0875e197&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports